import { useState, useEffect } from 'react';
import { Container, Table, Badge, Spinner } from 'react-bootstrap';
import { getPerformanceStatus } from '../../api/userApi';

const cyan = '#00e5ff';
const th = { color: cyan, fontWeight: 600, fontSize: 13, padding: '14px 20px', border: 'none' };

const RANKS = [
  'STAR-10', 'STAR-20', 'STAR-30', 'STAR-40', 'STAR-50', 'STAR-60',
  'STAR-70', 'STAR-80', 'STAR-90', 'STAR-100', 'STAR-1000', 'STAR-10000',
];

const PerformanceBonus = () => {
  const [performance, setPerformance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getPerformanceStatus()
      .then((res) => setPerformance(res.data.performance))
      .catch((err) => setError(err.response?.data?.message || 'Failed to load performance data.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <Container className="mt-5 text-center">
      <Spinner animation="border" style={{ color: cyan }} />
    </Container>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 40 }}>
      <Container className="pt-4">
        <h5 style={{ color: '#fff', fontWeight: 700, marginBottom: 4 }}>Performance Bonus</h5>
        <div style={{ color: '#888', fontSize: 13, marginBottom: 8 }}>
          Hit rank milestones by growing your team in each slot.
        </div>
        <div style={{ color: '#555', fontSize: 12, marginBottom: 24 }}>
          Eligibility: 10 direct referrals who have purchased the respective slot.
        </div>

        {error && (
          <div style={{ color: '#ff6666', background: 'rgba(200,50,50,0.12)', border: '1px solid rgba(200,50,50,0.3)', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontSize: 13 }}>
            {error}
          </div>
        )}

        <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(0,229,255,0.12)' }}>
          <Table responsive className="mb-0" style={{ background: 'transparent' }}>
            <thead>
              <tr style={{ background: 'rgba(0,229,255,0.07)', borderBottom: '1px solid rgba(0,229,255,0.15)' }}>
                <th style={th}>Rank</th>
                <th style={th}>Slot</th>
                <th style={th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {performance.map((row, idx) => (
                <tr
                  key={row.plan._id}
                  style={{
                    borderBottom: '1px solid rgba(255,255,255,0.05)',
                    background: idx % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent',
                  }}
                >
                  <td style={{ color: '#ffaa44', fontWeight: 700, fontSize: 14, padding: '14px 20px', border: 'none' }}>
                    {RANKS[idx] || `STAR-${row.plan.amount}`}
                  </td>
                  <td style={{ padding: '14px 20px', border: 'none' }}>
                    <div style={{ color: '#fff', fontWeight: 600, fontSize: 13 }}>{row.plan.planName}</div>
                    <div style={{ color: '#66ff99', fontSize: 12, marginTop: 2 }}>{row.plan.amount} USDT</div>
                    <div style={{ color: '#aaa', fontSize: 11, marginTop: 4 }}>10 direct referrals · <span style={{ color: cyan }}>{row.directCount}/10</span></div>
                  </td>
                  <td style={{ padding: '14px 20px', border: 'none' }}>
                    {row.achieved ? (
                      <Badge style={{ background: 'rgba(102,255,153,0.15)', color: '#66ff99', border: '1px solid #66ff9955', fontWeight: 500, fontSize: 12, padding: '5px 12px' }}>
                        Achieved
                      </Badge>
                    ) : (
                      <Badge style={{ background: 'rgba(255,255,255,0.04)', color: '#555', border: '1px solid rgba(255,255,255,0.08)', fontWeight: 500, fontSize: 12, padding: '5px 12px' }}>
                        Pending
                      </Badge>
                    )}
                  </td>
                </tr>
              ))}
              {performance.length === 0 && !error && (
                <tr>
                  <td colSpan={3} style={{ color: '#555', textAlign: 'center', padding: '32px', border: 'none' }}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Container>
    </div>
  );
};

export default PerformanceBonus;
